import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { useStoreSelector } from '../../hooks/useStoreSelector';
import { selectors, stateKeys } from '../../model';
import { useHandlers } from '../../contexts';
import styles from './SearchField.module.scss';

const { selectValue } = selectors;

const DELAY = 500;

const searchSelector = (state) => selectValue(state, stateKeys.search);

const SearchField = () => {
  const search = useStoreSelector(searchSelector);
  const { onSearchChange } = useHandlers();

  const [value, setValue] = useState(search);

  // Для повышения производительности
  // значение поиска записывается в стейт через debounce
  useEffect(() => {
    let timeout = null;

    timeout = setTimeout(() => {
      onSearchChange(value);
    }, DELAY);

    return () => clearTimeout(timeout);
  }, [value, onSearchChange]);

  useEffect(() => {
    setValue(search);
  }, [search]);

  return (
    <Input.Search
      className={styles.root}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      autoFocus
    />
  );
};

export default SearchField;
